import { useEffect, useState, useRef } from "react";
import AttestationRow from "./attestation.row";
import SearchContainer from "./search-container.component";
import "./index.scss";
import { postRequest } from "../../../../Utils/commonApi";
import { useAuth } from "../../../context/Auth";
import useApiActions from "../../../../hooks/api-actions.hook";
import useToggleRow from "../../../../hooks/toggle-row.hook";
import { useEntity } from "../../../../hooks/use-entity.hook";
import { FlaggersMethods } from "../../../../common/store/flaggers/flaggers.methods";
import { Flaggers } from "../../../../common/store/flaggers/flaggers.enum";
import useActions from "../../../../hooks/service-actions.hook";
import { PracticeEffectActions } from "../../../../common/services/security-stack-view/practice.service";
import { SecurityStackViewEffectActions } from "../../../../common/services/security-stack-view/security-stack-view.service";
import useNoteSection from "../../note-section/note-section.data";
import { ReplaceIntegrationTypes } from "../../../../constants/integrations.constants";
import ReplaceToolModal from "../../ReplaceToolModal";

interface IProps {
  toolData: any[];
  clientId: number;
  isView?: boolean;
  refreshIntegrsInfo: (tool: any) => void;
  refreshTechToolData: () => void;
}

const BrowseByTechnology = ({
  toolData,
  clientId,
  refreshIntegrsInfo,
  refreshTechToolData,
  isView = false,
}: IProps) => {
  const { authTokens }: any = useAuth();
  const { submitQuestionNote, updateToolToYes, checkToolInUse, removeIntegration, deleteIntegration } = useApiActions();
  const [searchMspTools, setSearchMspTools] = useState("");
  const { isLoading: isNoteLoading, submitNote } = useNoteSection();
  const [replaceToolData, setReplaceToolData] = useState<any>(null);
  const { refreshPanelStates } = useToggleRow({ rowRef: null, parentId: "stack-wrapper" as any, panelVisibleOut: true });
  const { setEntityData: setToolModal } = useEntity({ entityType: Flaggers.UpdateToolModalFlagger });
  const { setEntityData: setPracticeModal } = useEntity({ entityType: Flaggers.UpdatePracticeModalFlagger });
  const { removePracticeTool } = useActions(PracticeEffectActions);
  const { getSecurityStackView } = useActions(SecurityStackViewEffectActions);

  function itemsLoading() {
    let isLoading = toolData?.some((toolRow) => {
      let integrationLoading = toolRow?.IntegrationList?.some(
        (integrationItem: any) => integrationItem?.loading === true
      );

      return integrationLoading || toolRow?.loading || toolRow?.addingNewTool;
    });

    return isLoading;
  }

  function addNewIntegration(
    technologyEnum: string,
    IntegrationId: string,
    toolName: string,
    selected: boolean = true
  ) {
    return new Promise((resolve, reject) => {
      postRequest(authTokens, "CreateIntegrationTechnologyTool", {
        Selected: selected,
        IsMultipleIntegrationAllowed: true,
        ToolName: toolName,
        ObjectId: IntegrationId,
        accessKey: JSON.parse(localStorage.getItem("user_MessageObj") || "{}"),
        IntegrationTechnology: technologyEnum,
      })
        .then((response) => {
          if (response?.mr?.Success) {
            refreshTechToolData();
            resolve(response);
          }
        })
        .catch((err) => {});
    });
  }

  function technologyAnswerState({
    technologyEnum,
    value,
  }: {
    technologyEnum: string;
    value: boolean;
  }) {
    if (value) {
      return submitQuestionNote({
        technologyEnum,
      } as any).finally(() => {
        refreshTechToolData();
      });
    } else {
      return updateToolToYes({
        technologyEnum,
      }).finally(() => {
        refreshTechToolData();
      });
    }
  }

  function handleSubmitNote({ noteValue, technologyEnum }: { noteValue: string, technologyEnum: string }) {
    return submitNote({
      noteValue,
      technologyEnum,
    } as any).then(() => {
      refreshTechToolData();
    });
  }

  function handleRemovePracticeTool({ practiceId, toolId }: { practiceId: string, toolId: string }) {
    removePracticeTool({
      toolId,
      practiceId,
      callback: () => {
        refreshTechToolData();
      },
    });
  }

  function handleRemoveIntegration({ integrationId, technologyEnum, isCustom, tool }: { integrationId: string, technologyEnum: string, isCustom: boolean, tool: any }) {
    return new Promise((resolve, reject) => {
      checkToolInUse({ integrationId }).then((response) => {
        const resInUseData = [
          response?.TotalClientCount > 0,
          response?.TotalProductCount > 0,
          response?.TotalServicesCount > 0,
          response?.TotalPackagesCount > 0
        ]?.filter(Boolean);
        if (resInUseData.length > 0) {
          setReplaceToolData({
            integrationId: tool?.IntegrationId,
            replaceType: ReplaceIntegrationTypes.REMOVE,
            inUseData: response,
            technologyEnum,
            technologyType: tool?.TechnologyTitle
          });
          resolve(true);
        } else {
          if (isCustom) {
            deleteIntegration({ integrationId }).finally(() => {
              refreshTechToolData();
              resolve(true);
            });
          } else {
            removeIntegration({ integrationId, technologyEnum }).finally(() => {
              refreshTechToolData();
              resolve(true);
            });
          }
        }
      })
    })
  }

  function onToolClick(tool: any) {
    setToolModal({
      show: true,
      tool,
    }, FlaggersMethods.UpdateFlagger);
  }

  function onPracticeClick(practice: any) {
    setPracticeModal({
      show: true,
      practice,
    }, FlaggersMethods.UpdateFlagger);
  }

  useEffect(() => {
    refreshPanelStates();
    setTimeout(() => {
      refreshPanelStates();
    }, 350);
  }, [toolData]);
  
  useEffect(() => {
    getSecurityStackView({ clientId });
  }, [])

  return (
    <div className="browse-by-technology-container">
      <div
        className={`${itemsLoading() ? "stop-all-events" : ""}`}
        id="stack-wrapper"
      >
        <SearchContainer
          title="Enter tool or technology"
          value={searchMspTools}
          onChange={setSearchMspTools}
        />
        {toolData?.map((tool, toolIndex) => (
          <AttestationRow
            key={`tool-${toolIndex}`}
            tool={tool}
            searchMspTools={searchMspTools}
            onToolClick={onToolClick}
            onPracticeClick={onPracticeClick}
            removePracticeTool={handleRemovePracticeTool}
            refreshIntegrsInfo={refreshIntegrsInfo}
            toolData={toolData}
            rowParentId="stack-wrapper"
            addNewIntegration={addNewIntegration}
            technologyAnswerState={technologyAnswerState}
            submitNote={({ noteValue }: { noteValue: string }) => handleSubmitNote({ noteValue, technologyEnum: tool?.TechnologyEnum })}
            removeIntegration={({ integrationId, technologyEnum, isCustom }: { integrationId: string, technologyEnum: string, isCustom: boolean }) => handleRemoveIntegration({ integrationId, technologyEnum, isCustom, tool })}
            isNoteLoading={isNoteLoading}
            isView={isView}
          />
        ))}
      </div>
      <ReplaceToolModal
        show={!!replaceToolData}
        selectedToolId={replaceToolData?.integrationId}
        technologyType={replaceToolData?.technologyType}
        technologyEnum={replaceToolData?.technologyEnum}
        replaceType={replaceToolData?.replaceType}
        inUseDataResponse={replaceToolData?.inUseData}
        setReplaceToolData={setReplaceToolData as any}
        hideModal={() => {
          setReplaceToolData(null);
        }}
        onReplaceTool={() => {
          refreshTechToolData();
        }}
        refreshData={() => {
          refreshTechToolData();
        }}
      />
    </div>
  );
};

export default BrowseByTechnology;
